import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom-v5-compat';
import { Toaster } from 'sonner';

import { ImpersonationBanner } from '../features/impersonation/ImpersonationBanner';
import { cn } from '../lib/cn';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ThemeProvider, useTheme } from './theme';

// Legacy [public/index.html] pins viewport=width=1366 for the legacy app.
// While v2 is mounted we swap it to mobile-native so responsive Tailwind
// breakpoints actually take effect on phones; restore it on unmount so the
// legacy chrome keeps rendering at its expected width.
function useMobileViewport() {
    useEffect(() => {
        const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
        if (!meta) return;
        const previous = meta.getAttribute('content');
        meta.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');
        return () => {
            if (previous != null) meta.setAttribute('content', previous);
        };
    }, []);
}

function ShellInner() {
    const { theme } = useTheme();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    useMobileViewport();

    return (
        <div className={cn(theme === 'dark' && 'dark')}>
            <div className="v2-root flex h-screen overflow-hidden bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
                <Toaster
                    richColors
                    closeButton
                    position="top-right"
                    theme={theme}
                />
                <Sidebar isOpen={isSidebarOpen} onNavigate={() => setSidebarOpen(false)} />
                <div className="flex min-w-0 flex-1 flex-col">
                    <Header onToggleSidebar={() => setSidebarOpen((open) => !open)} />
                    <ImpersonationBanner />
                    <main className="flex-1 overflow-y-auto">
                        <Suspense
                            fallback={
                                <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                                    Se incarca...
                                </div>
                            }
                        >
                            <Outlet />
                        </Suspense>
                    </main>
                </div>
            </div>
        </div>
    );
}

export function Shell() {
    return (
        <ThemeProvider>
            <ShellInner />
        </ThemeProvider>
    );
}
